/**
 * @generated SignedSource<<f9e10ea1d8b74d589d9539a7dcda5814>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld$data = {
  readonly createdField: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField">;
  } | null | undefined;
  readonly resolutionDateField: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField">;
  } | null | undefined;
  readonly updatedField: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField">;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld";
};
export type ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld$key = {
  readonly " $data"?: ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld",
  "selections": [
    {
      "concreteType": "JiraDateTimePickerField",
      "kind": "LinkedField",
      "name": "createdField",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField"
        }
      ]
    },
    {
      "concreteType": "JiraDateTimePickerField",
      "kind": "LinkedField",
      "name": "updatedField",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField"
        }
      ]
    },
    {
      "concreteType": "JiraDateTimePickerField",
      "kind": "LinkedField",
      "name": "resolutionDateField",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "cfbc77a1aac5a54b7f7424cf9533c092";

export default node;
